module.exports = __webpack_public_path__ + "2a74ccd3ac634bae9eeb0c4af03f9849.png";